import { styled } from 'baseui'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

export const ModalOverrides = {
  Dialog: {
    style: () => ({
      borderRadius: '2rem',
      overflow: 'hidden',
    }),
  },
}

export const HeaderContainer = styled('div', () => ({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '0.5rem 1rem',
}))

export const StyledIcon = styled('img', () => ({
  marginRight: '0.45rem',
  width: '1.5rem',
  height: '1.5rem',
}))

export const TitleText = styled('h3', () => ({
  marginTop: 0,
  marginBottom: 0,
  marginRight: 0,
  marginLeft: '0.5rem',
  fontSize: '1.2rem',
  fontWeight: '600',
  color: '#343535',
}))

export const OptionsContainer = styled('div', () => ({
  display: 'flex',
  justifyContent: 'space-around',
  padding: '0.25rem 0',
}))

export const OptionCardStyled = styled('div', () => ({
  width: '8rem',
  height: '7.5rem',
  border: '0.1rem solid #D6D7D8',
  borderRadius: '0.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'border-color 0.3s ease',
  ':hover': {
    border: '0.25rem solid #015AA3',
    '--icon-color': '#015AA3',
  },
}))

export const OptionIconWrapper = styled('div', () => ({
  width: '2.8rem',
  height: '2.8rem',
  marginBottom: '0.85rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'var(--icon-color, #808284)',
  transition: 'color 0.3s ease',
  '& svg': {
    width: '100%',
    height: '100%',
    fill: 'currentColor',
  },
}))

export const OptionText = styled('span', () => ({
  fontSize: '1.2rem',
  color: '#343535',
}))

export const ButtonsContainer = styled('div', () => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0.75rem',
}))

export const CancelButton = styled(SDButton, () => ({
  width: 'calc(50% - 0.5rem)',
  backgroundColor: '#fff',
  color: '#B30F16',
  border: '0.1rem solid #B30F16',
  borderRadius: '1rem',
  ':hover': {
    backgroundColor: '#B30F16',
    color: '#fff',
  },
}))

export const ConfirmButton = styled(SDButton, () => ({
  width: 'calc(50% - 0.5rem)',
  backgroundColor: '#fff',
  color: '#015AA3',
  border: '0.1rem solid #015AA3',
  borderRadius: '1rem',
  ':hover': {
    backgroundColor: '#015AA3',
    color: '#fff',
  },
}))
